module.exports = __webpack_public_path__ + "static/media/YELLOW BOX.d149839c.png";